// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchPerformers[data-v-684c00aa]{align-items:center;color:#000;display:flex;width:100%}.searchPerformers[data-v-684c00aa]:hover{color:#0084fc;font-weight:700}.avatar[data-v-684c00aa]{background-image:url(/img/result/results_back.png);background-position:top;background-size:cover;border-radius:50%;height:150px;width:150px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
